import { Box } from '@ff-it/ui';
import { CampaignWidget, ClientTitle, SelectionChip } from 'components';
import { PeriodWidget } from 'components/PeriodWidget';
import { ListCampaign } from 'modules/campaign/campaign/types';

type CampaignChipProps = {
  campaign: ListCampaign;
  onRemove?: (id: number) => void;
  disabled?: boolean;
};

export function CampaignChip({ campaign, onRemove, disabled }: CampaignChipProps) {
  return (
    <SelectionChip
      disabled={disabled}
      onRemove={onRemove ? () => onRemove(campaign.id) : undefined}
      testId={`campaing-chip-${campaign.id}`}
    >
      <Box display="flex" flexGrow={1}>
        <CampaignWidget link {...campaign} />
      </Box>
      <Box borderLeft="subtle" alignSelf="stretch" />
      <ClientTitle {...campaign} />
      <Box borderLeft="subtle" alignSelf="stretch" />
      <PeriodWidget
        alignSelf="center"
        textSize="xxs"
        date_from={campaign.date_from}
        date_to={campaign.date_to}
        vertical
        style={{ lineHeight: '1.3' }}
        color="gray500"
      />
    </SelectionChip>
  );
}
